import type { ImageLoader } from 'next/image';

/**
 * Одна запись srcset: ширина, которую запросит next/image,
 * и подписанный imgproxy-URL с `rs:fit` под эту ширину.
 */
export interface SignedSrcSetEntry {
  width: number;
  url: string;
}

/**
 * Создаёт loader для next/image поверх заранее подписанных URL.
 *
 * Подписать URL на клиенте нельзя — ключи imgproxy серверные, поэтому
 * набор ширин подписывается на сервере (см. `getSignedSrcSet`), а loader
 * только выбирает готовый URL: ближайшая ширина не меньше запрошенной,
 * иначе самая большая из доступных.
 *
 * @param entries - Записи, отсортированные по возрастанию ширины.
 */
export const createSignedSrcSetLoader =
  (entries: SignedSrcSetEntry[]): ImageLoader =>
  ({ width }) =>
    (
      entries.find((entry) => entry.width >= width) ??
      entries[entries.length - 1]
    ).url;
